module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1135.b3215cf5.png";